<template>
  <v-container class="ma-0" style="max-width: unset">
    <v-row>
      <v-col class="px-0">
        <p class="mb-2 select-label font-weight-bold">Branche wählen</p>
        <v-select v-model="selectedSector"
                  :items="sectorItems"
                  class="mb-3"
                  dense
                  hide-details
                  item-text="name"
                  item-value="id"
                  outlined
                  style="max-width: 420px;"
        />

        <fin-data-table v-model="sectorSelectedShares"
                        :headers="tableHeaders"
                        :height="540"
                        :resolver="resolver"
                        fixed-header
                        show-select
                        shrink-to-view-port
                        sticky-first-col
                        class="mt-6"/>
      </v-col>
    </v-row>
    <v-row>
      <v-col align="right">
        <v-btn class="mr-4"
               @click="$router.push({ name: 'finToolsRateShares'})"
               v-if="!sector">
          Zurück zur Aktien-Suche
        </v-btn>

        <v-btn class="mr-4"
               @click="$emit('closeCompareGroupMode')"
               v-if="sector">
          Zurück zur Bewertung
        </v-btn>

        <v-btn dark
               @click="$emit('copySelectionToCustomGroup')">
          <v-icon>icon-plus</v-icon>
          Auswahl übernehmen
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import FinDataTable from "@/components/common/DataTable/FinDataTable"
import {TablePresets} from "@/components/common/DataTable/DefaultHeaders"
import {API, graphqlOperation} from "@/plugins/finAmplifyModules"
import {searchSharesBySector} from "@/views/protected/finTools/rate/shares/graphql"

export default {
  name: "finSectorTab",
  components: {FinDataTable},
  props: {
    selectedShares: {
      type: Array,
      default: () => []
    },
    sectorItems: {
      type: Array,
      default: () => []
    },
    sector: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      resolver: [],
      sectorSelectedShares: this.selectedShares,
      selectedSector: null,
    }
  },
  computed: {
    tableHeaders() {
      return TablePresets.createShareRatingHeaders()
    },
  },
  methods: {
    async getTableData(options) {
      if (this.selectedSector) {
        const {sortBy, sortDesc, page, itemsPerPage} = options

        const params = {
          from: (page - 1) * itemsPerPage,
          limit: itemsPerPage,
          sort: sortBy?.length > 0 ? {field: sortBy[0], direction: sortDesc[0] ? 'asc' : 'desc'} : {
            field: 'name',
            direction: 'asc'
          },
          filter: {gicsCode: {matchPhrasePrefix: this.selectedSector}}
        }

        const resultSet = await API.graphql(graphqlOperation(searchSharesBySector, params))

        return resultSet.data.searchShares
      } else {
        return []
      }
    },
  },
  mounted() {
    if (this.sector) {
      this.selectedSector = this.sector.id
    }
  },
  watch: {
    selectedSector() {
      this.resolver = (options) => this.getTableData(options)
    },
    selectedShares() {
      this.sectorSelectedShares = this.selectedShares
    },
    sectorSelectedShares() {
      this.$emit('input', this.sectorSelectedShares)
    }
  }
}
</script>

<style scoped>

</style>
